import React from "react"
import Container from "@mui/material/Container"
import HowToUseContent from "@/shared/components/how-to-use"

export default function HowToUse() {
  return (
    <Container id="how-to-use" sx={{ pt: { xs: 2, sm: 4 }, pb: { xs: 8, sm: 12 } }}>
      <HowToUseContent />
    </Container>
  )
}
